<template>
  <path
    d="M17 3.00018H7C5.9 3.00018 5 3.90018 5 5.00018V21.0002L12 18.0002L19 21.0002V5.00018C19 3.90018 18.1 3.00018 17 3.00018ZM17 18.0002L12 15.8202L7 18.0002V6.00018C7 5.45018 7.45 5.00018 8 5.00018H16C16.55 5.00018 17 5.45018 17 6.00018V18.0002Z"
  />
</template>
